<template>
  <div class="push-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input v-model="params.videoID" placeholder="请输入视频ID" size="small" class="param-input" clearable></el-input>
      <el-button type="primary" size="small" @click="recommendList('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="videoID" label="视频ID" align="center" min-width="120"></el-table-column>
      <el-table-column prop="title" label="视频标题" align="center" min-width="120"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="220">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
       <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeVideo(scope.row.videoID)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 10, 15, 20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 5" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from "@/api"
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        videoID: ''
      }
    }
  },
  created() {
    this.recommendList()
  },
  methods: {
    // 获取列表
    recommendList(type) {
      if(type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.recommendList(this.params).then(res => {
        if (res.code === 200 && res.data.vInfos.length > 0) {
          this.total = res.data.total;
          this.tableData = res.data.vInfos
        } else {
          this.tableData = []
          this.total = 0
        }
          this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // 删除推送视频
    removeVideo(id) {
      this.$confirm('您确定要删除当前推送视频吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          API.cancelRecommend({IDs: [id]}).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
              this.recommendList()
            } else {
              this.$message.error('删除失败!');
            }
          })
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.recommendList(this.params)
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.recommendList(this.params)
    },
  }
}
</script>